import React from 'react';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const Export = ({
  csvData,
  fileName,
  columnMapper,
  disabled,
  buttonText = 'Export Excel'
}) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const exportToCSV = (thisCsvData, thisFileName) => {
    if (!thisCsvData) {
      return null;
    }

    const newCsvData = thisCsvData.map(columnMapper);
    const ws = XLSX.utils.json_to_sheet(newCsvData);
    const wb = { Sheets: { data: ws }, SheetNames: [ 'data' ] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([ excelBuffer ], { type: fileType });
    FileSaver.saveAs(data, thisFileName + fileExtension);
  };

  return (
    <button
      disabled={ disabled }
      className='btn btn-success'
      onClick={ e => exportToCSV(csvData, fileName) }>
      {buttonText}
    </button>
  );
};

export default Export;
